module.exports = "/_next/static/images/hand-c314e7c8c556125329d78d9f7685c17d.png";